import type { ContentWith$$Relations } from '@generalTypes/apiTypes';
import { contentApi } from '@store/api/apiConfig';
import type { Snapshot } from './documentSnapshotTypes';

export const getSnapshotsForDocument = async (documentKey: string): Promise<Snapshot[]> => {
  return contentApi.getAll(`/documents/${documentKey}/snapshots`);
};

export const getSnapshotContent = async (
  documentKey: string,
  version: string,
): Promise<ContentWith$$Relations[]> => {
  return contentApi.getAll(`/documents/${documentKey}/snapshots/${version}/content`, {
    limit: 6000,
  });
};
